import "./style.scss";

import React, {useState} from "react";
import FormSteps from "./formSteps";
import CreatePermissions from "./createPermissions";
import CreateUserInfo from "./createUserInfo";
import Alert from "../../components/common/alert";
import {MESSAGES} from "../../constants";
import {useDispatch, useSelector} from "react-redux";
import {clearCreateUserAlerts, clearCreateUserErrors, createUserProfile} from "../../actions/users";
import createPermissions from "./createPermissions";
import {Navigate} from "react-router-dom";

export const route = "create-user";

const FORM_STEPS = [
  {
    step: 1,
    name: 'user-info',
    label: 'User Info'
  },
  {
    step: 2,
    name: 'permissions',
    label: 'Permissions'
  }
];

const CreateUser = () => {
  const dispatch = useDispatch();

  const currentStep = useSelector((state) => state.users.createUserCurrentStep);
  const createUserErrors = useSelector((state) => state.users.createUserErrors);
  const userFormErrors = useSelector((state) => state.users.userFormErrors);
  const savePermissionsSuccess = useSelector((state) => state.users.saveUserPermissionsApiSuccess);

  const userInfoSubmitAction = (formData) => {
    dispatch(createUserProfile(formData));
  }

  return (savePermissionsSuccess) ? <Navigate to='/users'/> :  (
    <div className='main-content'>
      <div className='user-profile-header'>Create a New User</div>
      <div className='create-user-alerts'>
        {(createUserErrors) && <Alert messageType='error' onDismiss={() => dispatch(clearCreateUserErrors())}>{MESSAGES.USERS.createUserErrors}</Alert>}
      </div>
      <div className='user-form-steps'>
        <FormSteps items={FORM_STEPS} currentStep={currentStep}/>
      </div>
      <div className='user-profile-container'>
        {currentStep === 'permissions' ? <CreatePermissions/> : <CreateUserInfo onSubmitAction={userInfoSubmitAction} errors={userFormErrors}/>}
      </div>
    </div>
  );
}

export default CreateUser;